<template>
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="currentColor"
    aria-hidden="true">
    <path
      d="M12 3c2.6 0 4.2 1.9 4.2 4.6 0 .8-.05 1.5-.1 2 .5.3 1 .2 1.6-.1.6-.3 1.2.5.6 1-.5.4-1.4.7-1.7 1.2-.2.5.6 1.6 1.7 2.4 1 .7 2.1.9 2.1 1.4 0 .6-1.4.7-1.8 1-.2.2-.1.6-.3.9-.2.2-.7.1-1.3.1-.7 0-1.4.2-2 .6-.6.4-1.3.9-2.3.9s-1.7-.5-2.3-.9c-.6-.4-1.3-.6-2-.6-.6 0-1.1.1-1.3-.1-.2-.3-.1-.7-.3-.9-.4-.3-1.8-.4-1.8-1 0-.5 1.1-.7 2.1-1.4 1.1-.8 1.9-1.9 1.7-2.4-.3-.5-1.2-.8-1.7-1.2-.6-.5 0-1.3.6-1 .6.3 1.1.4 1.6.1-.05-.5-.1-1.2-.1-2C7.8 4.9 9.4 3 12 3z" />
  </svg>
</template>
